import React, { useEffect, useState } from "react";
import TransactionTable from "../components/TransactionTable";
import { DEFAULT_CHAIN, afterDate, api_key, contract, dateFormat, networkQuery, transactionQuery } from "../helper/constant";
import { useTokenInfoStats } from "../hooks/useTokenInfo";
import { useSidebar } from "../context/useSidebar";

export default function Transactions() {
  const [page, setPage] = useState(0);
  const { isSidebarOpen, isRightSidebarOpen } = useSidebar();
  const [dexData, setDexData] = useState([]);
  const [loading, setLoading] = useState(true);
  const stats = useTokenInfoStats(1);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const variables = {
    limit: 10,
    offset: page,
    network: networkQuery,
    token: contract[DEFAULT_CHAIN].BARC_ADDRESS,
    after: afterDate,
    dateFormat: dateFormat,
  };

  useEffect(() => {
    try {
      var config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": api_key,
        },
        body: JSON.stringify({
          query: transactionQuery,
          variables: variables,
        }),
      };

      fetch("https://graphql.bitquery.io", config)
        .then((response) => response.json())
        .then((response) => {
          if (response.data) {
            setDexData(response.data.ethereum.dexTrades);
            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            console.log(response);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (err) {
      console.log(err.message);
    }

    // eslint-disable-next-line
  }, [page]);

  return (
    <div
      className={`content-body default-height bg-primary-gradient ${isSidebarOpen ? "sidebar-open-page-margin" : "sidebar-close-page-margin"}`}
      style={{
        paddingRight: screenWidth > 1700 && isRightSidebarOpen ? "26.75rem" : "0",
      }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="page-titles">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="#sec">Transaction</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Recent Transactions
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <TransactionTable dexData={dexData} loading={loading} setLoading={setLoading} stats={stats} page={page} setPage={setPage} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
